<div class="app-toast__content" [ngClass]="type" #toast role="status" [attr.tabindex]="TAP_getTabindex()">
	<span class="app-toast__text">{{ message }}</span>
	<app-svg *ngIf="showClose" class="app-toast__close" svg="icons.svg#general--close" (click)="dismissToast()" [alt]="'Dismiss Toast icon'" aria-label="Dismiss Toast"></app-svg>
</div>
